"use client";
import { useState, useRef, useEffect } from "react";
import Product from "@/public/images/product.png";
import Image from "next/image";
import Link from "next/link";
import Percent from "@/public/icon/discount.svg";
import Rating from "@/public/icon/rating.svg";
import Bag from "@/public/icon/shopping-bag.svg";
import New from "@/public/icon/new.svg";
import Award from "@/public/icon/award.svg";
import Stock from "@/public/icon/stock.svg";
import Fav from "@/public/icon/fav.svg";
import AddToCartPopup from "../AddToPopup/AddToPopup";
import { useWishlist } from "@/hooks/useWishlist";

const ProductCard = ({ item, t, isAuthenticated = false }) => {
  const [isActive, setIsActive] = useState(false);
  const { isWished, addToWishlist, removeFromWishlist, wishlistItems } =
    useWishlist();
  const wished = isWished(item.id);
  const [isWishedActive, setIsWishedActive] = useState(wished);

  useEffect(() => {
    setIsWishedActive(wished);
  }, [wished]);
  const toggleWishlist = () => {
    addToWishlist(item.id);
    setIsWishedActive(!isWishedActive);
  };
  const handleClick = () => {
    setIsActive(!isActive);
  };

  return (
    <>
      {isActive ? (
        <AddToCartPopup key={`product_item_${item.id}`} product={item} t={t} />
      ) : null}
      <div className={`productCard ${!isWishedActive ? "active" : ""} `}>
        {isAuthenticated && (
          <div
            className={`favButton ${isWishedActive ? "active" : ""}`}
            onClick={toggleWishlist}
          >
            <Fav />
          </div>
        )}
        <div className="badges">
          {item?.sticker?.id === 4 && (
            <div className="sale badge">
              <Award />
              {item?.sticker?.title}
            </div>
          )}

          {item?.sticker?.id === 1 && (
            <div className="new badge">
              <New />
              {item?.sticker?.title}
            </div>
          )}
          {item?.out_of_stock === 1 && (
            <div className="stock badge">
              <Stock />
              {t["forms.out_of_stock"]}
            </div>
          )}
        </div>
        <Link href={`/products/${item.alias}?id=${item.id}`} className="img">
          <Image
            src={item.title_image.main}
            alt="product"
            width={500}
            height={500}
          />
        </Link>
        <div className="productBody">
          {item.sale_percent && Number(item?.sale_percent) > 0 ? (
            <div className="percent badge">{`${item.sale_percent} %`}</div>
          ) : null}
          <div className="price">
            {item.max_price && item.max_price > 0 ? (
              // 🔹 Qiymət aralığı halı
              item.min_price_sale &&
              item.max_sale_price &&
              (item.min_price_sale !== item.min_price ||
                item.max_sale_price !== item.max_price) ? (
                <>
                  <p>
                    {item.min_price_sale
                      ? item.min_price_sale + "₼"
                      : item.min_price + "₼"}
                    {" - "}
                    {item.max_sale_price
                      ? item.max_sale_price + "₼"
                      : item.max_price + "₼"}
                  </p>
                  <span>
                    {item.min_price + "₼"} - {item.max_price + "₼"}
                  </span>
                </>
              ) : (
                <p>
                  {item.min_price + "₼"} - {item.max_price + "₼"}
                </p>
              )
            ) : // 🔹 Tək qiymət halı (max_price = 0)
            item.min_price_sale &&
              item.min_price_sale !== 0 &&
              item.min_price_sale !== item.min_price ? (
              <>
                <p>{item.min_price_sale + "₼"}</p>
                <span>{item.min_price + "₼"}</span>
              </>
            ) : (
              <p>{item.min_price + "₼"}</p>
            )}
          </div>

          <div className="detail">
            <p>{item.title}</p>
            <div className="ratingParent">
              {item?.rating === 0 ? null : (
                <>
                  <Rating />({item?.rating} )
                </>
              )}
            </div>
            {item?.out_of_stock === 1 ? (
              <button type="button" className="blackButton outofStockButton">
                {t["forms.out_of_stock"]}
              </button>
            ) : (
              <button
                type="button"
                className="blackButton"
                onClick={() => handleClick()}
              >
                <Bag />
                {t["buttons.add_to_basket"]}
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductCard;
